@if (service.items().length) {
  <div class="win-toast-stack" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    @for (t of service.items(); track t.id) {
      <app-win-toast
        animate.enter="win-toast-enter"
        [game]="t.game"
        [skins]="t.skins"
        [totalValue]="t.totalValue"
        [offerUrl]="t.offerUrl"
        (close)="service.dismiss(t.id)"
      />
    }
  </div>
}
